module.exports = ".modal {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  max-width: 600px;\n  font-family: Roboto, sans-serif;\n  color: #25358f; }\n  .modal .margin-bottom {\n    margin-bottom: 30px; }\n  .modal .x-button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: 10px;\n    cursor: pointer; }\n  .modal .header {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/new-portal-alert/new-portal-alert.component.scss
// module id = 176
// module chunks = 1